import { IUserData } from '../../types/interfaces';
import { ISetAuth, ISetSectionId, ISetUserData } from '../types/actions';
import { ActionTypes } from '../types/actionTypes';

const initialState = {
  isAuth: false,
  userData: {} as IUserData,
  sectionId: '',
};

export interface IUserState {
  isAuth: boolean;
  userData: IUserData;
  sectionId: any;
}

type ActionType = ISetAuth | ISetUserData | ISetSectionId;

export default function user(state: IUserState = initialState, action: ActionType) {
  switch (action.type) {
    case ActionTypes.SET_AUTH:
      return { ...state, isAuth: action.payload };
    case ActionTypes.SET_SECTION_ID:
      return { ...state, sectionId: action.payload };
    case ActionTypes.SET_USER_DATA:
      return { ...state, userData: action.payload };

    default:
      return state;
  }
}
